import { Component } from '@angular/core';
import { ImportsModule } from '../imports';
import { MessagingService } from '../services/messaging.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [ImportsModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {

  constructor(private messagingService: MessagingService) {
  }
}
